<template>
  <div id="register" class="body-container" v-title :data-title="$t('titleText.create_account')">
    <basicheader :login="false"></basicheader>
    <div class="body-content">
      <div class="account-wrapper">
        <div class="slogan-wrapper">
          <span class="slogan-text">{{ $t("register.register") }}</span>
        </div>
        <div class="register-wapper">
          <div class="register-head">
            <router-link class="register-tab" to="/phone" active-class="active">
              <span class="tab-item">{{ $t("register.phone_register") }}</span>
            </router-link>
            <router-link class="register-tab email-tab" to="/email" active-class="active">
              <span class="tab-item last">{{ $t("register.email_register") }}</span>
            </router-link>
          </div>

          <div class="content-wrapper">
            <router-view :lang="lang"></router-view>
          </div>
        </div>
      </div>
    </div>
    <czurfooter @changeAppLocale="changeAppLocale"></czurfooter>
  </div>
</template>

<script>
import czurfooter from 'components/footer/footer'
import Config from 'common/script/config.js'
import basicheader from 'components/header/header'
export default {
  name: 'register',
  data () {
    return {
      lang: ''
    }
  },
  components: {
    czurfooter,
    basicheader
  },
  methods: {
    changeLanguage (lang) {
      this.$i18n.locale = lang
      this.lang = lang
      Config.cookieSet('lang', lang)
    },
    changeAppLocale (locale) {
      this.changeLanguage(locale)
    }
  },
  mounted () {
    this.changeLanguage(this.$i18n.locale)
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#register
  min-height 7.88rem
  &.body-container
    .body-content
      .account-wrapper
        width 5rem
        height 7.8rem
        //left 50%
        //top 50%
        //margin-top -3.35rem
        //margin-left -2.5rem

  .register-wapper
    clear both
    .register-head
      clear both
      display block
      width 3.51rem
      margin 0 auto
      overflow hidden
      color #cccccc
      font-size 0.18rem
      line-height 0.15rem
      text-align center
      margin-top 0.44rem
      margin-bottom 0.44rem
      .register-tab
        width 1.75rem
        float left
        color #adadad
        font-size 0.15rem
        line-height 20px
        text-align center
        margin 10px 0
        font-weight 300
        border-right 1px solid #D8D8D8
      .email-tab
        width 1.74rem
        border-right none
      .active
        color #272f44
</style>



// WEBPACK FOOTER //
// register.vue?0c2e6401